export const SET_INFO = 'SET_INFO';
export const SET_CURRENT = 'SET_CURRENT';
export const SET_AGREEMENT = 'SET_AGREEMENT';
export const SET_USER_INFO = 'SET_USER_INFO';
export const TOGGLE_TOAST = 'TOGGLE_TOAST';
export const SET_QRCODE = 'SET_QRCODE';
export const TOGGLE_SHOWINFO = 'TOGGLE_SHOWINFO';
export const SET_SHAREIMG = 'SET_SHAREIMG';
export const SET_RECOMMEND_LIST = 'SET_RECOMMEND_LIST';
export const SET_FINAL_LIST = 'SET_FINAL_LIST';
export const REFRESH_LIST = 'REFRESH_LIST';
export const SET_CLIENT_HEIGHT = 'SET_CLIENT_HEIGHT';
export const SET_WIDTH = 'SET_WIDTH';
export const SET_HEIGHT = 'SET_HEIGHT';
export default {
    [SET_INFO](state, info) {
        state.info = info;
        if (info.page1 && Object.keys(info.page1).length) {
            // without data
            if (!info.page1.year_comic_time) {
                return (state.totalCount = 1);
            }
            else {
                // others
                let _s = 8;
                if (Object.keys(info.page5).length === 0 || (Object.keys(info.page5).length > 0 && !info.page5.season_title)) {
                    _s -= 1;
                }
                if (Object.keys(info.page7).length === 0 || !info.page7.famous_scene_urls || info.page7.famous_scene_urls.length < 3 || info.page7.famous_scene_urls.some(i => !i)) {
                    _s -= 1;
                }
                state.totalCount = _s;
            }
        }
    },
    [SET_CURRENT](state, type) {
        if (type === 'prev') {
            state.current -= 1;
        }
        if (type === 'next') {
            state.current += 1;
        }
    },
    [SET_AGREEMENT](state, value) {
        state.isAgree = value;
    },
    [SET_USER_INFO](state, info) {
        state.userInfo = info;
    },
    [TOGGLE_TOAST](state, visible) {
        state.toastVisible = visible;
    },
    [SET_QRCODE](state, url) {
        state.qrcodeImg = url;
    },
    [TOGGLE_SHOWINFO](state, visible) {
        state.showInfo = visible;
    },
    [SET_SHAREIMG](state, { url, type }) {
        if (type) {
            state.showInfoImg = url;
        }
        else {
            state.hideInfoImg = url;
        }
    },
    [SET_RECOMMEND_LIST](state, list) {
        state.movieList = list;
    },
    [SET_FINAL_LIST](state, list) {
        state.finalList = list;
    },
    [SET_CLIENT_HEIGHT](state, height) {
        state.height = height;
    },
    [REFRESH_LIST](state) {
        const ufList = state.finalList.length;
        const maxPage = Math.ceil(ufList / 4);
        state.pageNo = state.pageNo + 1 >= maxPage ? 0 : state.pageNo + 1;
    },
    [SET_WIDTH](state, w) {
        state.h5Width = w;
    },
    [SET_HEIGHT](state, h) {
        state.h5Height = h;
    },
};
